import { produce } from 'immer';
import { NodeMaterializationState } from 'app/lib/constants';
import { extractError } from 'app/lib/error';
import { CANCEL_QUERY } from 'app/store/snowflakeQueries/types.js';
import { TOGGLE_MATERIALIZATION_DIALOG, TABLE_MATERIALIZATION } from './types.js';

export const INITIAL_STATE = {
    sessionId: null,
    materialization: {
        isDialogOpen: false,
        viewUuid: null,
        tablesByViewUuid: {},
        isLoading: false,
        error: null
    }
};

export const materializeReducer = produce((draft, action) => {
    switch (action.type) {
        case TOGGLE_MATERIALIZATION_DIALOG: {
            const { isOpen, viewUuid } = action.payload;
            draft.materialization.isDialogOpen = isOpen;
            draft.materialization.viewUuid = isOpen ? viewUuid : null;
            draft.materialization.error = null;
            break;
        }
        case CANCEL_QUERY.STARTED:
            draft.materialization.isLoading = true;
            break;
        case CANCEL_QUERY.ENDED:
            draft.materialization.isLoading = false;
            break;

        case TABLE_MATERIALIZATION.STARTED: {
            const viewUuid = action.meta.viewUuid;
            draft.materialization.error = null;
            draft.materialization.isLoading = true;
            draft.materialization.tablesByViewUuid = {
                ...draft.materialization.tablesByViewUuid,
                [viewUuid]: { state: NodeMaterializationState.RUNNING }
            };
            break;
        }
        case TABLE_MATERIALIZATION.PROGRESS: {
            if (action.responseName === 'TableMaterializationInitiated') {
                const { queryId } = action.payload;
                const { viewUuid } = action.meta;

                draft.materialization.isDialogOpen = false;
                draft.materialization.viewUuid = null;
                draft.materialization.isLoading = false;
                draft.materialization.tablesByViewUuid[viewUuid].queryId = queryId;
            }
            break;
        }
        case TABLE_MATERIALIZATION.SUCCEEDED: {
            const viewUuid = action.meta.viewUuid;
            draft.materialization.tablesByViewUuid[viewUuid].state =
                NodeMaterializationState.SUCCESS;
            break;
        }
        case TABLE_MATERIALIZATION.FAILED: {
            const viewUuid = action.meta.viewUuid;
            draft.materialization.error = extractError(action.payload);
            draft.materialization.tablesByViewUuid[viewUuid].state =
                NodeMaterializationState.INVALID;
            break;
        }
        case TABLE_MATERIALIZATION.ENDED: {
            const viewUuid = action.meta.viewUuid;
            draft.materialization.isLoading = false;
            delete draft.materialization.tablesByViewUuid[viewUuid].queryId;
            break;
        }
        default:
    }
}, INITIAL_STATE);
